import React from 'react';

export default () => <div className="loader loader-lg loader-primary" />;
